var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-label"},[_c('the-btn',{staticClass:"btn btn-block btn-secondary px-3 py-1",class:{ 'no-hover': !_vm.hoverable },attrs:{"text":_vm.text},nativeOn:{"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }